import axios from 'axios';
import { getBackendURL } from '@/util.js';
import { Message } from '@/msg.js';

export default class ChatService {
    constructor() {
        const baseURL = getBackendURL();
        this.urls = {
            createThread: `${baseURL}/v1/thread/create`,
            createMsg: `${baseURL}/v1/msg/create`,
            getMsgs: `${baseURL}/v1/msg/get`,
            getThreads: `${baseURL}/v1/thread/get`,
            generate: `${baseURL}/v1/thread/assistant/generate`,
        }
    }

    msgToObject(msg) {
        return {
            retry_count: msg.retry_count,
            role: msg.role,
            content: msg.content,
        }
    }

    async createThread(msg) {
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.post(
                this.urls.createThread,
                this.msgToObject(msg),
                {
                    withCredentials: true
                }
            );
            res.data = response.data;
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async createMsg(msg, threadID) {
        let res = {
            data: null,
            error: null
        }
        let msg_obj = this.msgToObject(msg)
        msg_obj.thread_id = threadID
        try {
            const response = await axios.post(
                this.urls.createMsg,
                msg_obj,
                {
                    withCredentials: true
                }
            );
            res.data = response.data;
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async getMsgs(threadID, offset, limit, order) {
        let res = {
            msgs: [],
            error: null
        }
        try {
            const response = await axios.get(`${this.urls.getMsgs}/${threadID}?offset=${offset}&limit=${limit}&order=${order}`, {
                withCredentials: true
            });
            for (let msg of response.data) {
                res.msgs.push(new Message(msg.role, msg.content))
            }
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async getThreads(offset, limit, order) {
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.get(`${this.urls.getThreads}?offset=${offset}&limit=${limit}&order=${order}`, {
                withCredentials: true
            });
            res.data = response.data;
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async generate(threadID) {
        let res = {
            error: null
        }
        try {
            await axios.post(`${this.urls.generate}/${threadID}`, {}, { withCredentials: true })
        } catch (error) {
            res.error = error;
        }
        return res;
    }
}
